import { getLanguages } from 'utils/languages'
import { getFields } from './tabs/Competencies/model'
import { formToModules, modulesToForm } from './model'

export const mapInternalStateToPayload = state => {
  const {
    absence,
    category,
    competencies,
    description,
    languages,
    modules,
    position,
    productivity,
    template,
    turnover,
    positions,
    department,
    members_with_access,
  } = state

  const payload = {
    category: category?.value,
    department: department.value,
    description,
    ...(positions && { positions }),
    interview_template:
      template !== null && template !== undefined ? template.value : null,
    languages: languages.map(({ value }) => value),
    modules: formToModules(modules),
    name: position,
    profile: {
      categories: competencies.reduce(
        (acc, { name, ...rest }) => ({ ...acc, [name]: rest[name] }),
        {},
      ),
      outputVariables: {
        isProductivityEnabled: !!productivity,
        isSicknessAbsenceEnabled: !!absence,
        isTurnoverEnabled: !!turnover,
      },
    },
    ...(members_with_access && { members_with_access }),
  }

  return payload
}

export const mapTemplateToInternalState = state => {
  const {
    category,
    description = '',
    interview_template,
    languages = [],
    modules = {},
    name = '',
    positions,
    profile: {
      categories,
      outputVariables: {
        isProductivityEnabled,
        isSicknessAbsenceEnabled,
        isTurnoverEnabled,
      } = {},
    } = {},
    department,
    members_with_access,
  } = state ?? {}

  const noPriorityBool =
    !isProductivityEnabled && !isSicknessAbsenceEnabled && !isTurnoverEnabled

  const formState = {
    absence: isSicknessAbsenceEnabled,
    category: category ? { label: category, value: category } : null,
    department: { label: department?.name, value: department?.id },
    competencies:
      categories && Object.keys(categories).length > 0
        ? Object.entries(categories)
            .sort(([current], [next]) =>
              current < next ? -1 : current > next ? 1 : 0,
            )
            .map(([name, value]) => ({ [name]: value, name }))
        : getFields(),
    description,
    languages:
      languages.length === 0
        ? getLanguages()
        : languages.map(key =>
            getLanguages().find(({ value }) => value === key),
          ),
    modules: modulesToForm(modules),
    position: name,
    ...(positions && { positions }),
    productivity: isProductivityEnabled,
    ...(interview_template &&
      modules.interview && {
        template: {
          label: interview_template,
          value: interview_template,
        },
      }),
    ...(members_with_access && {
      members_with_access: members_with_access?.map(member => member.id),
    }),
    turnover: isTurnoverEnabled,
    noPriority: noPriorityBool,
  }

  return formState
}
